
class FacetedFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    window.addEventListener('popstate', this.onHistoryChange.bind(this));

    this.addClickOutsideHandler(document);
  }

  addClickOutsideHandler(container) {
    const displays = container.querySelectorAll('.facets__display');
    displays.forEach((item) => {
      hideOnClickOutside(item);
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActiveFacets();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    let { resultsContainer, sectionId, resultsGrid } = this.dataset;

    document.querySelector(resultsContainer).querySelector(resultsGrid).classList.add('loading');

    let url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    const filterDataUrl = element => element.url === url;

    this.filterData.some(filterDataUrl) ?
      this.renderSectionFromCache(filterDataUrl, event) :
      this.renderSectionFromFetch(url, event);

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];
        this.renderFilters(html, event);
        this.renderProductGrid(html);
        this.renderProductCount(html);
      });
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html, event);
    this.renderProductGrid(html);
    this.renderProductCount(html);
  }

  renderProductGrid(html) {
    const results = this.dataset.resultsContainer;
    document.querySelector(results).innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector(results).innerHTML;
  }

  renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ResultsProductCount').innerHTML
    const containerDesktop = document.getElementById('ResultsProductCountDesktop');
    document.getElementById('ResultsProductCount').innerHTML = count;
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
    }
  }

  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetedFiltersForm .js-filter, #FacetedFiltersFormMobile .js-filter');
    const matchesIndex = (element) => element.dataset.index === event?.target.closest('.js-filter')?.dataset.index
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    const currentDisclosures = document.querySelectorAll('#FacetedFiltersFormMobile .js-filter');
    const newDisclosures = parsedHTML.querySelectorAll('#FacetedFiltersFormMobile .js-filter');

    if (this.shouldRedendersAllDisclosures(parsedHTML)) {
      this.renderDisclosures(parsedHTML);
    } else {
      const currentFacets = Array.from(facetDetailsElements).filter(element => matchesIndex(element));
      currentFacets.forEach((element) => {
        const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
        target.setAttribute('class', element.getAttribute('class'));
        if (target.dataset.index.includes('mobile')) {
          target.open = true;
          setTimeout(() => { target.classList.add('menu-opening') });
        }
      });

      facetsToRender.forEach((element) => {
        const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
        if (! target) {
          return;
        }
        target.innerHTML = element.innerHTML;
        target.setAttribute('class', element.getAttribute('class'));
      });
    }

    this.addClickOutsideHandler(document);

    this.renderActiveFacets(parsedHTML);
    this.renderAdditionalElements(parsedHTML);

    if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  shouldRedendersAllDisclosures(parsedHTML) {
    let current = []; let brandnew = [];
    const currentDisclosures = document.querySelectorAll('#FacetedFiltersFormMobile .js-filter');
    const newDisclosures = parsedHTML.querySelectorAll('#FacetedFiltersFormMobile .js-filter');

    currentDisclosures.forEach(item => current.push(item.dataset.name));
    newDisclosures.forEach(item => brandnew.push(item.dataset.name));

    return current.join('-').length != brandnew.join('-').length;
  }

  renderDisclosures(parsedHTML) {
    const disclosuresWrapperSelector = '#FacetedFiltersForm .facets__wrapper';
    const disclosuresWrapper = document.querySelector(disclosuresWrapperSelector);
    disclosuresWrapper.innerHTML = parsedHTML.querySelector(disclosuresWrapperSelector).innerHTML;

    const disclosuresWrapperMobileSelector = '#FacetedFiltersFormMobile .mobile-facets__main';
    const disclosuresWrapperMobile = document.querySelector(disclosuresWrapperMobileSelector);
    disclosuresWrapperMobile.innerHTML = parsedHTML.querySelector(disclosuresWrapperMobileSelector).innerHTML;
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    this.toggleActiveFacets(false);
  }

  renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetedFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.count-bubble','.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  getSections() {
    // homc - refactor
    return [
      {
        id: 'main-collection-product-grid',
        section: document.querySelector('.main-collection-product-grid').dataset.sectionId,
      }
    ]
  }
}

customElements.define('faceted-filters-form', FacetedFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input').forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.querySelectorAll('input[type="range"]').forEach(element => element.addEventListener('input', this.onSliderChange));

    this.setMinAndMaxValues();
    this.initSlider();
  }

  initSlider() {
    const slider = PriceRange.getSliderElements(this);

    if (! slider.inputLeft) {
      return;
    }

    // Percentages
    const perecentage = Number(slider.inputLeft.value) * 100 / Number(slider.inputLeft.getAttribute('max'));
    const inversePercentage = 100 - perecentage;

    const perecentageTwo = Number(slider.inputRight.value) * 100 / Number(slider.inputRight.getAttribute('max'));
    const inversePercentageTwo = 100 - perecentageTwo;

    slider.inverseLeft.style.width = inversePercentage + '%';
    slider.inverseRight.style.width = inversePercentage + '%';
    slider.range.style.left = perecentage + '%';
    slider.range.style.right = inversePercentageTwo + '%';
    slider.thumbLeft.style.left = perecentage + '%';
    slider.thumbRight.style.left = perecentageTwo + '%';
  }

  onRangeChange(event) {
    if (event.currentTarget.classList.contains('handle')) {
      this.syncValuesFromSlider();
      return;
    }
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onSliderChange(event) {
    var input = event.currentTarget;
    const container = input.closest('.facets__price');
    const slider = PriceRange.getSliderElements(container);

    if (input.dataset.handle === 'left') {
      input.value = Math.min(input.value, slider.inputRight.value - 1);
      const value = (100/(parseInt(input.max) - parseInt(input.min))) * parseInt(input.value) - (100/(parseInt(input.max) - parseInt(input.min))) * parseInt(input.min);

      slider.inverseLeft.style.width = value + '%'; 
      slider.range.style.left = value + '%';
      slider.thumbLeft.style.left = value + '%';
    }

    if (input.dataset.handle === 'right') {
      input.value = Math.max(input.value, slider.inputLeft.value - (-1));
      const value = (100/(parseInt(input.max)-parseInt(input.min)))*parseInt(input.value)-(100/(parseInt(input.max)-parseInt(input.min)))*parseInt(input.min);

      slider.inverseRight.style.width = (100 - value) + '%';
      slider.range.style.right = (100 - value) + '%';
      slider.thumbRight.style.left = value + '%';
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input:not([type="range"])');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  syncValuesFromSlider() {
    const sliderInputs = this.querySelectorAll('input[type="range"]');

    const sliderMinInput = sliderInputs[0];
    const sliderMaxInput = sliderInputs[1];

    const inputs = this.querySelectorAll('input:not([type="range"])');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (minInput.value !== sliderMinInput.value) {
      minInput.value = Number(sliderMinInput.value);
      minInput.dispatchEvent(new Event('input', {bubbles: true, cancelable: true}));
    }

    if (maxInput.value !== sliderMaxInput.value) {
      maxInput.value = Number(sliderMaxInput.value);
      maxInput.dispatchEvent(new Event('input', {bubbles: true, cancelable: true}));
    }
  }

  static getSliderElements(container) {
    return {
      'inverseLeft': container?.querySelector('div[inverse-left]'),
      'inverseRight': container?.querySelector('div[inverse-right]'),
      'range': container?.querySelector('div[range]'),
      'thumbLeft': container?.querySelector('span[thumb-left]'),
      'thumbRight': container?.querySelector('span[thumb-right]'),
      'inputLeft': container.querySelector('input[data-handle="left"]'),
      'inputRight': container.querySelector('input[data-handle="right"]')
    };
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('faceted-filters-form') || document.querySelector('faceted-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const trapFocusHandlers = {};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function hideOnClickOutside(element) {

  const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)

  const outsideClickListener = event => {
    if (!element.contains(event.target) && isVisible(element)) {
      element.closest('details')?.removeAttribute('open');
    }
  }

  document.addEventListener('click', outsideClickListener)
}

// MenuDrawer duplicates in collection-filters.js
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);